import WizardStepper from '@/components/ui/wizard-stepper';
import type { PaymentRun } from '@/lib/api/billing';
import { ablaufSchritte, aktuellerSchritt } from './zahlungslaufSchritte';

export default function ZahlungslaufAblauf({ run }: Readonly<{ run: PaymentRun }>) {
  const schritte = ablaufSchritte(run);
  const aktuell = aktuellerSchritt(run);
  if (run.status === 'cancelled') {
    return (
      <div className="rounded-lg border bg-muted/40 p-3 text-sm text-muted-foreground">
        Dieser Lauf wurde abgebrochen. Seine Posten sind wieder offen und kommen in den nächsten Lauf.
      </div>
    );
  }
  const fertig = aktuell > schritte.length;
  return (
    <div className="space-y-2">
      <WizardStepper
        currentStep={aktuell}
        totalSteps={schritte.length}
        steps={schritte.map((s) => ({ label: s.label }))}
      />
      <div className="rounded-lg border border-primary/30 bg-primary/5 p-3 text-sm">
        {fertig ? (
          <span className="font-medium">Abgeschlossen — alle Aufträge sind verbucht.</span>
        ) : (
          <>
            <span className="font-medium">
              Nächster Schritt {aktuell} von {schritte.length}: {schritte[aktuell - 1]?.label}.{' '}
            </span>
            <span className="text-muted-foreground">{schritte[aktuell - 1]?.hinweis}</span>
          </>
        )}
      </div>
    </div>
  );
}
